module.exports = __webpack_public_path__ + "static/media/arrow_right.e0a572df.svg";